module.exports = __webpack_public_path__ + "static/img_5098-f34e9bf398422c836b823681f135403b.webp";